import * as _ from 'lodash';
import moment from 'moment';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import {utils} from "../../../utils/shopifyInjector/utils";

class OrderSetupDialogController {
    static $inject = [
        '$scope', '$window', 'cartonomyConfig',
        '$rootScope', '$mdDialog', 'Message',
        'tabToShow',
        'initialConfiguration',
        'UserProfile', 'GroupOrder', 'paymentOptions', 'editMode', 'Session', 'LocalForageService', 'CartService', '$state', 'HeapService', 'initialCart', '$translate'];

    constructor(scope, windowService, cartonomyConfig,
                rootScope, dialogService, messageService,
                tabToShow,
                initialConfiguration,
                userProfileService, groupOrderService, paymentOptions, editMode, sessionService, localForageService, cartService, stateService, HeapService, initialCart, $translate) {

        this._scope = scope;
        this._cartonomyConfig = cartonomyConfig;
        this._rootScope = rootScope;
        this._initialConfiguration = initialConfiguration;
        this._dialogService = dialogService;
        this._tabToShow = tabToShow;
        this._tabBeforeCancel = null;
        this._groupOrderService = groupOrderService;
        this._userProfileService = userProfileService;
        this._scope.groupPay = groupOrderService.getGroupPay();
        this._paymentOptions = paymentOptions;
        this._scope._editMode = editMode;
        this._windowService = windowService;
        this._messageService = messageService;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this._cartService = cartService;
        this._sessionService = sessionService;
        this._stateService = stateService;
        this._heapService = HeapService;
        this._initialCart = initialCart;
        this.$translate = $translate;

        scope.hasMandatoryDeadline = !!rootScope.retailer.mandatoryDeadline;

        // onboarding
        scope.onboarding = {
            steps: 5,
            currentStep: 0
        };

        scope.onboardingNextStep = () => {
            console.log(scope.onboarding.currentStep);
            scope.onboarding.currentStep++;
        };

        scope.onboardingPreviousStep = () => {
            scope.onboarding.currentStep--;
        };

        scope.returnToPreview = false;
        scope.resetConfiguration = () => this._resetConfiguration();
        scope.setCurrentTabById = id => this._setCurrentTabById(id);
        scope.showCancelTab = () => this._showCancelTab();
        scope.closeDialog = () => this._closeOrderDialog(true);
        scope.cancelOrder = () => this._closeOrderDialog();
        scope.restoreOrder = () => this._restoreOrder();
        scope.backEnabled = () => this._backEnabled();
        scope.back = () => this._back();
        scope.onDialogDeleteContact = (contact) => this._onDialogDeleteContact(contact);
        scope.cancelPreview = () => this._cancelPreview();
        scope.next = () => this._next();
        scope.finishOrderSetup = async () => this._finishOrderSetup();
        scope.previewTab = tabId => this._previewTab(tabId);
        scope.enableTab = (tabId, enable) => this._enableTab(tabId, enable);
        scope.isExternalRetailer = () => cartonomyConfig.externalStoreMode;
        scope.$on(Constants.Events.ORDER_CREATION_CANCEL_REQUESTED, () => this._closeOrderDialog());
        scope.$on(Constants.Events.OPEN_SPLASH_SCREEN, () => this._openSplashScreen());
        rootScope.$on(Constants.Events.BACK_BUTTON_CLICKED, () => this._closeOrderDialog());
        scope.formattedUserFirstName = "";

        scope.getStarted = () => this._getStarted();
        scope.singleInviteLink = () => this._singleInviteLink();
        scope.acceptDeleteContact = () => this._acceptDeleteContact();
        scope.backToCreateOrder = () => this._backToCreateOrder();
        scope.contactDelete = null;

        this.startTabIndex = null;
        this._initialize();
    }

    async _initialize() {
        this._scope.noBudgetMode = this._rootScope.retailer && this._rootScope.retailer.noBudgetMode;
        if (this._scope._editMode) {
            this._rootScope.storeWindowTitle = 'client.order.group_setting';
        } else if (!this._initialCart.$id) {
            this._rootScope.storeWindowTitle = 'client.order.group_creating';
        } else {
            this._rootScope.storeWindowTitle = 'client.order.group_join';
        }
        if (this._initialCart) {
            this._scope.deadline = this._initialCart.closeOn && moment(this._initialCart.closeOn).format('L LT') || 'client.unlimited';
            this._scope.budget = this._initialCart.orderLimit && this._rootScope.formatAmount(this._initialCart.orderLimit) || 'client.unlimited';
            this._scope.orderTitle = this._initialCart.cartName || this._initialCart.title;
            this._scope.payerTitle = this._initialCart.fulfillment && (this._initialCart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.SELF
                || this._initialCart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.MIXED) ?
                'client.order.group_member_pay' : 'client.order.group_owner_pay';
        }

        scopeUtils.apply(this._scope);
        this._scope.formattedUserFirstName = this.toPossessiveString(await this._sessionService.getUserFirstName());
        this._createTabs();
        await this._resetConfiguration();
        this._onUserAddressesReceived(await this._userProfileService.getUserAddresses());

        const storedCurrentTab = await this._localForageService.retrieve(Constants.SessionStorage.CREATE_ORDER_CURRENT_TAB);

        this.startTabIndex = 0;

        if (this._tabToShow) {
            const tab = _.find(this._scope.tabs, {id: this._tabToShow});
            tab.save = true;
            tab.disabled = false;
            const cancelTab = this._scope.tabs.find(tab => tab.id === Constants.OrderSetupTabs.CANCELEDITING);
            this._scope.tabs = [tab, cancelTab];
            this.startTabIndex = _.findIndex(this._scope.tabs, (t) => t.id === this._tabToShow);
        }

        this._scope.tabs.forEach(tab => {
            tab.templateUrl = 'modules/order/views/orderSetupTabs/' + tab.templateUrl;
        });

        if (this._paymentOptions) {
            this._groupOrderService.loadFromSessionStorage();
            this._setCurrentTabById(Constants.OrderSetupTabs.ADD_PEOPLE);
            return null;
        }

        if (storedCurrentTab && !this._tabToShow) {
            this._setCurrentTabById(storedCurrentTab);
            return;
        }

        this._setCurrentTab(this.startTabIndex);
    }

    toPossessiveString(name) {
        if (name[name.length - 1] === 's') {
            return `${name}'`;
        }

        return `${name}'s`;
    }

    async _getStarted() {
        await this._singleInviteLink();
        //this._setCurrentTabById(Constants.OrderSetupTabs.ADD_PEOPLE);
    }

    async _singleInviteLink() {
        this._scope.invitationCode = this._cartService.getInviteCode();
        if (!this._scope.invitationCode) {
            this._scope.invitationCode = await this._cartService.getInvitationCode();
            this._cartService.setInviteCode(this._scope.invitationCode);
            this._cartService.setInvitationType(Constants.InvitationTypes.share);
        }

        this._scope.returnToPreview = false;
        this._setCurrentTabById(Constants.OrderSetupTabs.PREVIEW);
    }

    async _resetConfiguration() {
        const storedConfiguration = await this._localForageService.retrieve(Constants.SessionStorage.CREATE_ORDER_CONFIGURATION);

        if (storedConfiguration) {
            await this._groupOrderService.loadConfiguration(JSON.parse(storedConfiguration));
        } else if (this._initialConfiguration) {
            await this._groupOrderService.loadConfiguration(this._initialConfiguration);
        } else {
            await this._groupOrderService.initConfiguration();
        }

        // external store: always pay for everyone - set this up before showing set up wizard
        if (this._cartonomyConfig.externalStoreMode) {
            this._groupOrderService.setGroupPay(this._groupOrderService.PayForEveryone);
            this._groupOrderService.setSinglePayOrder(this._groupOrderService.getSinglePayOrder() || {
                enterPaymentInformation: 'no'
            });
        }
    }

    _onUserAddressesReceived(addresses) {
        if (!addresses) {
            return;
        }

        this._scope.deliveryAddresses = addresses.filter(address => address.addressType === Constants.AddressType.SHIPPING)
            .map(address => {
                return {
                    label: address.address + (address.address2 ? (', ' + address.address2) : '') + ', ' + address.city + ', ' + address.state + ' ' + address.zip,
                    id: address.id,
                    source: address
                };
            });

        this._scope.deliveryAddresses.push({
            label: this.$translate.instant('client.user.address_enter'),
            id: 0
        });
    }

    _setCurrentTab(index) {
        this._scope.groupPay = this._groupOrderService.getGroupPay();
        this._scope.selectedIndex = index;
        let tab = this._scope.tabs[this._scope.selectedIndex];

        if (tab && tab.customAction) {
            tab.customAction();
            return;
        }

        this._scope.selectedTab = tab;

        scopeUtils.apply(this._scope);
    }

    _setCurrentTabById(id) {
        const tab = _.find(this._scope.tabs, {id: id});
        this._setCurrentTab(_.indexOf(this._scope.tabs, tab));
    }

    async _showCancelTab() {
        return;
        if (!this._scope._editMode) {
            await this._closeOrderDialog();
            return;
        }
        //
        // if (this._scope.selectedTab.id === Constants.OrderSetupTabs.CANCEL) {
        //     this._scope.restoreOrder();
        //     return;
        // }
        //
        // if (this._tabToShow && (this._scope._editMode || !this._cartonomyConfig.externalStoreMode)) {
        //     this._scope.cancelOrder();
        //     return;
        // }
        //
        this._tabBeforeCancel = this._scope.selectedTab.id;
        this._setCurrentTabById(Constants.OrderSetupTabs.CANCELEDITING);
    }

    async _openSplashScreen() {
        await this._resetConfiguration();
        this._setCurrentTabById(Constants.OrderSetupTabs.PREVIEW);
    }

    async _closeOrderDialog(forceClose) {
        if (this._scope._editMode || !this._cartonomyConfig.externalStoreMode || forceClose) {
            this._dialogService.cancel();
            this._rootScope.$broadcast(Constants.Events.DIALOG_CLOSED);
            return;
        }

        await this._localForageService.store(Constants.SessionStorage.CREATE_ORDER_CURRENT_TAB, this._scope.selectedTab.id);
        await this._localForageService.store(Constants.SessionStorage.CREATE_ORDER_CONFIGURATION, JSON.stringify(this._groupOrderService._configuration));

        if (!this._rootScope.collapsed) {
            if (!this._rootScope.orderCreationCancelRequested) {
                this._rootScope.toggleWindowState();
            }
            this._dialogService.cancel();
        }
    }

    _restoreOrder() {
        this._setCurrentTabById(this._tabBeforeCancel);
    }

    _backEnabled() {
        return (this._cartonomyConfig.externalStoreMode || !this._tabToShow) &&
            this._scope.selectedIndex > this.startTabIndex &&
            this._scope.selectedIndex <= this._scope.tabs.length - 1 &&
            !this._scope.returnToPreview &&
            this._scope.tabs[this._scope.selectedIndex].id !== Constants.OrderSetupTabs.FINISH &&
            !this._scope.tabs[this._scope.selectedIndex].disableBackButton;
    }

    _back() {
        if (this._scope.__editMode) {

        }
        let newIndex = this._scope.selectedIndex - 1;
        for (; newIndex > 0; newIndex--) {
            if (!this._scope.tabs[newIndex].disabled) {
                break;
            }
        }
        this._setCurrentTab(newIndex);
    }

    _onDialogDeleteContact = async (contact) => {
        this._scope.contactDelete = contact;
        await this._resetConfiguration();
        this._setCurrentTabById(Constants.OrderSetupTabs.CONFIRM_DELETE_CONTACT);
    }

    _cancelPreview() {
        this._scope.returnToPreview = false;
    }

    _next() {
        if ((this._scope._editMode || !this._cartonomyConfig.externalStoreMode) && this._tabToShow) {
            this._dialogService.hide();
            return;
        }

        if (this._scope.returnToPreview) {
            this._scope.returnToPreview = false;
            this._setCurrentTabById(Constants.OrderSetupTabs.PREVIEW);
            return;
        }

        let newIndex = this._scope.selectedIndex + 1;
        for (; newIndex < this._scope.tabs.length; newIndex++) {
            if (!this._scope.tabs[newIndex].disabled) {
                break;
            }
        }
        this._setCurrentTab(newIndex);
    }

    async _showFinishDialog() {
        await this._finishOrderSetup();
        // await this._messageService._showMessagePopup(
        //     `Your order setup is complete and invitations have been emailed.
        //     If participants do not receive their invites, you can ask them to check their spam folders,
        //     and you can also resend email invitations on the people invited tab on the group order pane.`,
        //     false,
        //     'Order Created');
    }


    async _finishOrderSetup() {
      await this._stateService.go(Constants.RoutingStates.CART);
      this._rootScope.$broadcast(Constants.Events.ORDER_CREATED);
      this._dialogService.hide();
      await this._localForageService.remove(Constants.SessionStorage.CREATE_ORDER_CONFIGURATION);
      await this._localForageService.remove(Constants.SessionStorage.CREATE_ORDER_CURRENT_TAB);
    }

    _previewTab(tabId) {
        this._scope.returnToPreview = true;
        this._scope.setCurrentTabById(tabId);
    }

    _enableTab(tabId, enable) {
        const tab = _.find(this._scope.tabs, {id: tabId});
        tab.disabled = !enable;
    }

    async _acceptDeleteContact() {
        // 1. Call api delete contact
        await this._groupOrderService.deleteContact(this._scope.contactDelete.contactUserId);

        // 2. back to Add people tab
        this._setCurrentTabById(Constants.OrderSetupTabs.ADD_PEOPLE);
    }

    _backToCreateOrder() {
        this._setCurrentTabById(Constants.OrderSetupTabs.ADD_PEOPLE);
    }

    _createTabs() {
        this._scope.tabs = [
            // {
            //     id: Constants.OrderSetupTabs.WELCOME,
            //     title: '',
            //     templateUrl: 'welcome.html',
            //     template: require('../views/orderSetupTabs/welcome.jade')()
            // },
            {
                id: Constants.OrderSetupTabs.PREVIEW,
                title: 'client.order.tab.finalize_details',
                templateUrl: 'preview.html',
                custom: true
            },
            {
                id: Constants.OrderSetupTabs.ADD_PEOPLE,
                title: 'client.order.tab.add_people',
                templateUrl: 'addPeople.html',
                custom: true,
                disableBackButton: true
            },
            {
                id: Constants.OrderSetupTabs.DELIVERY_MODE,
                title: 'client.order.tab.choose_delivery',
                templateUrl: 'deliveryMode.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            },
            {
                id: Constants.OrderSetupTabs.DELIVERY_ADDRESS,
                title: '',
                templateUrl: 'deliveryAddress.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            },
            {
                id: Constants.OrderSetupTabs.PAY_MODE,
                title: 'client.order.tab.who_pay',
                templateUrl: 'payMode.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            },
            {
                id: Constants.OrderSetupTabs.DEADLINE,
                title: '',
                templateUrl: 'deadline.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            },
            {
                id: Constants.OrderSetupTabs.BUDGET,
                title: '',
                templateUrl: 'budget.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            },
            {
                id: Constants.OrderSetupTabs.PAYMENT_DETAILS,
                title: 'client.order.tab.payment_info',
                templateUrl: 'paymentDetails.html',
                disabled: true
            },
            {
                id: Constants.OrderSetupTabs.FINISH,
                title: 'client.order.tab.all_set',
                templateUrl: 'finish.html',
                custom: true,
                customAction: async () => await this._showFinishDialog()
            },
            {
                id: Constants.OrderSetupTabs.CANCEL,
                title: 'client.order.tab.cancel_order',
                templateUrl: 'cancel.html',
                disabled: true,
                custom: true
            },
            {
                id: Constants.OrderSetupTabs.CANCELEDITING,
                title: 'client.order.tab.cancel_editing',
                templateUrl: 'cancelEditing.html',
                disabled: true,
                custom: true
            },
            {
                id: Constants.OrderSetupTabs.CONFIRM_DELETE_CONTACT,
                title: '',
                templateUrl: 'confirmDeleteContact.html',
                template: require('../views/orderSetupTabs/confirmDeleteContact.jade')()
            },
            {
                id: Constants.OrderSetupTabs.INVITE_WELCOME,
                title: '',
                templateUrl: 'inviteWelcome.html',
                template: require('../views/orderSetupTabs/inviteWelcome.jade')(),
                custom: true
            },

        ];
    }
}

export default OrderSetupDialogController;



// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderSetupDialogController.js